import { WorkflowRequestTypes } from "../models/requests/enums/WorkflowRequestTypes.enum";
import { WorkflowStates } from "../models/requests/enums/WorkflowStates.enum";
import { ChevronBrandColors } from "./brand/chevronBrandColors.enum";

export class ChartHelpers {
    static groupByAndCount<T, K extends keyof any>(list: T[], keyGetter: (item: T) => K): Map<K, number> {
        const map = new Map<K, number>();
        list.forEach((item) => {
            const key = keyGetter(item);
            const count = map.get(key) || 0;
            map.set(key, count + 1);
        });
        return map;
    }

    static getBrandColorByWorkflowState(workflowState: WorkflowStates): string {
        switch (workflowState) {
            case WorkflowStates.PendingApproval:
                return ChevronBrandColors.LightOrange; // Pending Approval - light orange
            case WorkflowStates.Completed:
                return ChevronBrandColors.MediumGreen; // Completed - medium green
            case WorkflowStates.PartiallyCompleted:
                return ChevronBrandColors.LightPurple; // Partially Completed - medium teal
            case WorkflowStates.Failed:
                return ChevronBrandColors.DarkRed; // Failed - dark red
            case WorkflowStates.Cancelled:
                return ChevronBrandColors.MediumGray; // Cancelled - medium gray
            case WorkflowStates.Rejected:
                return ChevronBrandColors.MediumOrange; // Rejected - medium orange
            case WorkflowStates.Approved:
                return ChevronBrandColors.MediumTeal; // Approved - medium teal
            case WorkflowStates.Submitted:
                return ChevronBrandColors.LightGray; // In Progress - light gray
            case WorkflowStates.Expired:
                return ChevronBrandColors.DarkGray; // Expired - dark gray
            case WorkflowStates.Processing:
                return ChevronBrandColors.MediumBlue; // Processing - medium blue
            default:
                return ChevronBrandColors.DarkPurple; // Default - dark purple
        }
    }
    
    static getBrandColorByWorkflowRequestType(type: WorkflowRequestTypes): string {

        switch (type) {
            /*Requests to create or grant something*/
            case WorkflowRequestTypes.ApplicationCreate:
            case WorkflowRequestTypes.ApplicationNewClientSecret:
            case WorkflowRequestTypes.ApplicationPermissionGrant:
            case WorkflowRequestTypes.ApplicationRoleGrant:
            case WorkflowRequestTypes.GroupCreate:
            case WorkflowRequestTypes.SecretCreate:
            case WorkflowRequestTypes.GuestCreate:
            case WorkflowRequestTypes.CocoUserCreate:
            case WorkflowRequestTypes.PrivilegeAccountCreate:
            case WorkflowRequestTypes.ServiceAccountCreate:
            case WorkflowRequestTypes.MailboxAccountCreate:
                return ChevronBrandColors.MediumGreen;

            /*Requests to update something*/
            case WorkflowRequestTypes.ApplicationUpdate:
            case WorkflowRequestTypes.ApplicationPermissionChange:
            case WorkflowRequestTypes.GroupUpdate:
            case WorkflowRequestTypes.GroupMembershipUpdate:
            case WorkflowRequestTypes.SecretUpdatePermissions:
            case WorkflowRequestTypes.GuestUpdate:
            case WorkflowRequestTypes.CocoUserUpdate:
            case WorkflowRequestTypes.ServiceAccountUpdate:
            case WorkflowRequestTypes.ApplicationNonChevronPermissionsUpdate:
            case WorkflowRequestTypes.SecretUserEnable:
                return ChevronBrandColors.MediumTeal;

            /*Requests to delete or revoke something*/
            case WorkflowRequestTypes.ApplicationDeleteClientSecret:
            case WorkflowRequestTypes.ApplicationPermissionRevoke:
            case WorkflowRequestTypes.SecretDelete:
            case WorkflowRequestTypes.GuestDelete:
            case WorkflowRequestTypes.CocoUserDelete:
            case WorkflowRequestTypes.ServiceAccountDelete:
            case WorkflowRequestTypes.PrivilegeAccountDelete:
                return ChevronBrandColors.MediumOrange;

            /*Security related requests*/
            case WorkflowRequestTypes.ServiceAccountDeferment:
            case WorkflowRequestTypes.CyberEventCompromisedSourcingCompanyCreate:
            case WorkflowRequestTypes.CyberEventCompromisedSourcingCompanyClose:
            case WorkflowRequestTypes.Tier0AttestationEscalation:
            case WorkflowRequestTypes.MfaReset:
            case WorkflowRequestTypes.AccountUnlock:
            case WorkflowRequestTypes.ServiceAccountDisable:
                return ChevronBrandColors.MediumPurple;

            default:
                return ChevronBrandColors.DarkBlue;
        }
    }
}